"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleButton = CircleButton;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Symbol = require("../Symbol");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Container = _styledComponents.default.button`
  align-items: center;
  background-color: ${p => p.theme.colors.raisinBlack};
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: inline-flex;
  line-height: 1;
  outline: 0;
  padding: ${(0, _polished.rem)(20)};

  &:active {
    transform: translateY(${(0, _polished.rem)(1)});
  }

  &:disabled {
    background-color: ${p => (0, _polished.lighten)(0.3, p.theme.colors.raisinBlack)};

    & > * {
      opacity: 0.35;
    }
  }
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A basic button component that should render nicely on any platform. It responds to a callback when pressed and
 * supports a minimal level of customization.
 *
 * @beta
 */
function CircleButton({
  disabled,
  onPress,
  symbol,
  testID
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-testid": testID,
    disabled: disabled,
    onClick: onPress
  }, /*#__PURE__*/_react.default.createElement(_Symbol.Symbol, {
    name: symbol,
    size: 2,
    variant: "outlined"
  }));
}